import naja from "naja";
import ScrollTo from "./ScrollTo";

export default class PaginationScroll {
    static init() {
        this.hook();

        naja.addEventListener('complete', (event) => {
            this.hook();
        });
    }

    static hook() {
        document.querySelectorAll('.pagination__link').forEach(link =>
            link.addEventListener('click', function() {
                ScrollTo.doScrolling('#filtrovani', 500);
            }, false)
        );
    }
}
